// Built-in imports
import React from "react";
import { motion } from "framer-motion";

// Internal imports
import { Wrapper } from "./hero-text.styles";
import ShrinkText from "../shrink-text/shrink-text.component";
import { topTextAni, bottomTextAni } from "../../utils/motion/motion.utils";
import { useAppContext } from "../../layout/layout";
import sectionWrapper from "../../hoc/sction-wrapper.component";

const HeroText = () => {
  const { lang } = useAppContext();
  return (
    <Wrapper>
      <motion.h1 {...topTextAni} className="h1">
        {/* READY */}
        <ShrinkText text={lang === "en" ? "READY" : "BEREITS"} />
      </motion.h1>
      <motion.h1 {...bottomTextAni} className="h2">
        <ShrinkText text={lang === "en" ? "TO GROW?!" : "ZU WACHSEN?!"} />
        {/* TO GROW */}
      </motion.h1>
    </Wrapper>
  );
};

export default sectionWrapper(HeroText);
